module.exports = __webpack_public_path__ + "assets/notifications-fill.3209f06c.svg";